// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion-title {
  margin-bottom: 0.5rem;
  left: 29.3%;
  position: absolute;
  top: 8%;
  width: 11%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::ng-deep .mat-mdc-expansion-panel:not([class*=mat-elevation-z]) {
  box-shadow: 0px 2px 2px -3px rgba(0, 0, 0, 0.2), 0px 2px 2px -2px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.example-header-pending {
  background-color: rgba(239, 157, 101, 0.5215686275);
}

.example-header-validated {
  background-color: rgba(27, 143, 17, 0.5215686275);
}

.example-header-unvalidated {
  background-color: rgba(230, 53, 53, 0.5215686275);
}

.example-header-waiting {
  background-color: rgba(44, 81, 148, 0.5215686275);
}

.mat-mdc-card-avatar {
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
}

.ngx-datatable .datatable-footer {
  display: none;
  width: 100%;
  overflow: auto;
}

.doc-status {
  width: 65px;
  padding: 5px 10px;
  border-radius: 5px;
  color: white;
  line-height: 14px;
  height: 37px;
  text-align: center;
}

.namePerson {
  text-decoration: underline;
}

.bloc-header {
  margin-top: 25px;
  margin-bottom: 25px;
}

.column-infos {
  text-align: center;
  text-transform: capitalize;
}

.bloc-header .header {
  color: #104a64;
  font-weight: 700;
}

@media screen and (max-width: 1068px) {
  .bloc-header .header {
    font-size: 0.9rem;
  }
}
::ng-deep {
  /*TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/
  /*TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/
}
::ng-deep mat-accordion {
  width: 95%;
  margin: auto;
}
::ng-deep mat-expansion-panel mat-expansion-panel-header {
  padding: 40px 20px;
  margin: 10px 0 0 0;
}
::ng-deep .mat-mdc-tab-label-active {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 7px 7px 0 0;
  opacity: 1 !important;
}
::ng-deep .mat-mdc-tab-label-active .tab-title {
  color: #673ab7;
  font-weight: 700;
}
::ng-deep .mat-mdc-tab-labels {
  margin-left: 30px;
  width: 400px;
  border-bottom: #104a64;
}

.receivers {
  left: 66.3%;
  position: absolute;
  top: 8%;
}

::ng-deep .accordion-type {
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0.5rem;
  margin-left: 0.5rem;
  white-space: nowrap;
}

.createdAt {
  width: 7%;
  position: absolute;
  left: 51%;
}

.expireDate {
  width: 7%;
  position: absolute;
  left: 42%;
}

@media screen and (max-width: 1900px) {
  ::ng-deep .createdAt {
    width: 4%;
    font-size: 11px;
    position: 34%;
  }
  ::ng-deep .expireDate {
    width: 4%;
    font-size: 11px;
  }
}
@media screen and (max-width: 1450px) {
  ::ng-deep .accordion-type {
    height: 36px;
    line-height: 20px;
  }
}
@media screen and (max-width: 1664px) {
  ::ng-deep .accordion-type {
    margin-left: 10%;
  }
}
mat-panel-title {
  max-width: 10%;
}

.overflow {
  overflow: hidden;
  text-overflow: ellipsis;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}

::ng-deep .cdk-overlay-pane.mat-mdc-select-panel-above {
  width: auto !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+document-request/display-accordion-requests/display-accordion-requests.component.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EAEE,qBAAA;EAEA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,0HAAA;AAHF;;AAOA;EACE,mDAAA;AAJF;;AAOA;EACE,iDAAA;AAJF;;AAOA;EACE,iDAAA;AAJF;;AAMA;EACE,iDAAA;AAHF;;AAMA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;AAHF;;AAMA;EACE,aAAA;EACA,WAAA;EACA,cAAA;AAHF;;AAMA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,gBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,0BAAA;AAHF;;AAOE;EACE,cCvEY;EDwEZ,gBAAA;AAJJ;;AAOA;EAEI;IACE,iBAAA;EALJ;AACF;AASA;EAwBE,yHAAA;EAiBA,yHAAA;AA9CF;AAQE;EACE,UAAA;EACA,YAAA;AANJ;AAUI;EACE,kBAAA;EACA,kBAAA;AARN;AAsBE;EAEE,yCAAA;EACA,0CAAA;EACA,2CAAA;EACA,0BAAA;EACA,qBAAA;AArBJ;AAuBI;EACE,cAAA;EACA,gBAAA;AArBN;AA4BE;EACE,iBAAA;EACA,YAAA;EACA,sBAAA;AA1BJ;;AA8BA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;AA3BF;;AA8BA;EACE,uBAAA;EACA,gBAAA;EAEA,qBAAA;EACA,mBAAA;EACA,mBAAA;AA5BF;;AAgCA;EACE,SAAA;EACA,kBAAA;EACA,SAAA;AA7BF;;AAgCA;EACE,SAAA;EACA,kBAAA;EACA,SAAA;AA7BF;;AAgCA;EACE;IACE,SAAA;IACA,eAAA;IACA,aAAA;EA7BF;EA+BA;IACE,SAAA;IACA,eAAA;EA7BF;AACF;AAgCA;EACE;IACE,YAAA;IACA,iBAAA;EA9BF;AACF;AAoCA;EACE;IACE,gBAAA;EAlCF;AACF;AAqCA;EACE,cAAA;AAnCF;;AAqCA;EACE,gBAAA;EACA,uBAAA;AAlCF;;AAoCA;EACE,kCAAA;AAjCF;;AAqCA;EACE,sBAAA;AAlCF","sourcesContent":["@import \"/src/styles/_variables.scss\";\r\n\r\n.accordion-title {\r\n  //text-indent: 50px;\r\n  margin-bottom: 0.5rem;\r\n  // font-size: 1rem;\r\n  left: 29.3%;\r\n  position: absolute;\r\n  top: 8%;\r\n  width: 11%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n::ng-deep .mat-mdc-expansion-panel:not([class*=\"mat-elevation-z\"]) {\r\n  box-shadow: 0px 2px 2px -3px rgba(0, 0, 0, 0.2),\r\n    0px 2px 2px -2px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.example-header-pending {\r\n  background-color: #ef9d6585;\r\n}\r\n\r\n.example-header-validated {\r\n  background-color: #1b8f1185;\r\n}\r\n\r\n.example-header-unvalidated {\r\n  background-color: #e6353585;\r\n}\r\n.example-header-waiting {\r\n  background-color: #2c519485;\r\n}\r\n\r\n.mat-mdc-card-avatar {\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n  object-fit: cover;\r\n}\r\n\r\n.ngx-datatable .datatable-footer {\r\n  display: none;\r\n  width: 100%;\r\n  overflow: auto;\r\n}\r\n\r\n.doc-status {\r\n  width: 65px;\r\n  padding: 5px 10px;\r\n  border-radius: 5px;\r\n  color: white;\r\n  line-height: 14px;\r\n  height: 37px;\r\n  text-align: center;\r\n}\r\n\r\n.namePerson {\r\n  text-decoration: underline;\r\n}\r\n\r\n.bloc-header {\r\n  margin-top: 25px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.column-infos {\r\n  text-align: center;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.bloc-header {\r\n  .header {\r\n    color: $primary-color;\r\n    font-weight: 700;\r\n  }\r\n}\r\n@media screen and (max-width: 1068px) {\r\n  .bloc-header {\r\n    .header {\r\n      font-size: 0.9rem;\r\n    }\r\n  }\r\n}\r\n\r\n::ng-deep {\r\n  $back-color: #104a64;\r\n\r\n  mat-accordion {\r\n    width: 95%;\r\n    margin: auto;\r\n  }\r\n\r\n  mat-expansion-panel {\r\n    mat-expansion-panel-header {\r\n      padding: 40px 20px;\r\n      margin: 10px 0 0 0;\r\n      // background-color: $back-color;\r\n    }\r\n\r\n    .mat-mdc-expansion-panel-content {\r\n      //   background-color: $back-color;\r\n    }\r\n  }\r\n\r\n  .mat-mdc-expanded:focus,\r\n  .mat-mdc-expanded:hover {\r\n    // background-color: $back-color !important;\r\n  }\r\n  /*TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/\r\n  .mat-mdc-tab-label-active {\r\n    $color-border: rgba(0, 0, 0, 0.12);\r\n    border-top: 1px solid $color-border;\r\n    border-left: 1px solid $color-border;\r\n    border-right: 1px solid $color-border;\r\n    border-radius: 7px 7px 0 0;\r\n    opacity: 1 !important;\r\n\r\n    .tab-title {\r\n      color: #673ab7;\r\n      font-weight: 700;\r\n    }\r\n  }\r\n\r\n  .mat-mdc-ink-bar {\r\n  }\r\n  /*TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/\r\n  .mat-mdc-tab-labels {\r\n    margin-left: 30px;\r\n    width: 400px;\r\n    border-bottom: #104a64;\r\n  }\r\n}\r\n\r\n.receivers {\r\n  left: 66.3%;\r\n  position: absolute;\r\n  top: 8%;\r\n}\r\n\r\n::ng-deep .accordion-type {\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  //text-indent: 50px;\r\n  margin-bottom: 0.5rem;\r\n  margin-left: 0.5rem;\r\n  white-space: nowrap;\r\n  // font-size: 1rem;\r\n}\r\n\r\n.createdAt {\r\n  width: 7%;\r\n  position: absolute;\r\n  left: 51%;\r\n}\r\n\r\n.expireDate {\r\n  width: 7%;\r\n  position: absolute;\r\n  left: 42%;\r\n}\r\n\r\n@media screen and (max-width: 1900px) {\r\n  ::ng-deep .createdAt {\r\n    width: 4%;\r\n    font-size: 11px;\r\n    position: 34%;\r\n  }\r\n  ::ng-deep .expireDate {\r\n    width: 4%;\r\n    font-size: 11px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1450px) {\r\n  ::ng-deep .accordion-type {\r\n    height: 36px;\r\n    line-height: 20px;\r\n  }\r\n  // ::ng-deep .doc-status{\r\n  //     margin-top:16px;\r\n  // }\r\n}\r\n\r\n@media screen and (max-width: 1664px) {\r\n  ::ng-deep .accordion-type {\r\n    margin-left: 10%;\r\n  }\r\n}\r\n\r\nmat-panel-title {\r\n  max-width: 10%;\r\n}\r\n.overflow {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}\r\n\r\n\r\n::ng-deep .cdk-overlay-pane.mat-mdc-select-panel-above{\r\n  width: auto !important;\r\n}","// Général\r\n$content-background-color: white;\r\n$primary-color: #104a64;\r\n$success-color: #badbcc;\r\n$success-text-color: #0f5132;\r\n$error-color: #f5c2c7;\r\n$error-text-color: #842029;\r\n$secondary-color: #e9af51;\r\n$secondary-color-light: #e9af51a1;\r\n$danger-color: rgb(255, 79, 79);\r\n$page-title-size: 2.3rem;\r\n$common-size: 1.05rem;\r\n$background-light: #104a64;\r\n\r\n// Header\r\n$width-logo: 145px;\r\n$filter-logo: brightness(0) invert(1);\r\n$header-height: 70px;\r\n$header-color-bottom-border: #cbd3db;\r\n\r\n// Left menu\r\n$left-menu-text-color: white;\r\n\r\n// GED\r\n$ged-background-hover-color: #e9af5128;\r\n$ged-folder-color: $primary-color;\r\n$ged-file-color: $primary-color;\r\n$ged-folder-color-hover: #0056b3;\r\n$ged-file-color-hover: #0056b3;\r\n\r\n// Data Tree\r\n$data-tree-left-menu-width: 300px;\r\n$data-tree-article-title-font-size: 2.8rem;\r\n$data-tree-highlight-color: $secondary-color;\r\n\r\n// See rooms\r\n$see-rooms-title-size: 1.7rem;\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
